import * as React from "react";

import { cn } from "~/utils";
import { formatPrice } from "~/utils/formatPrice";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  adornment?: React.ReactNode;
  adornmentClassName?: string;
  inputClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, adornment, adornmentClassName, inputClassName, value, onChange, ...props }, ref) => {
    return (
      <div
        className={cn(
          "border-input relative flex max-w-[600px] items-center rounded-md border bg-white text-black",
          className,
        )}
      >
        <input
          type={type}
          className={cn(
            "placeholder:text-muted-foreground focus-visible:ring-ring flex h-9 w-full rounded-md border-none bg-transparent px-3 py-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
            adornment ? "pr-0" : "",
            inputClassName,
          )}
          value={value}
          onChange={onChange}
          ref={ref}
          {...props}
        />
        <div className="absolute right-0 flex items-center">
          {adornment && (
            <div className={cn("flex items-center justify-center px-4", adornmentClassName)}>{adornment}</div>
          )}
        </div>
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };

export function PriceInput({ value, setValue }: { value: number; setValue: (value: number) => void }) {
  return (
    <div className="relative w-full">
      <Input
        name="sellingPrice"
        type="text"
        pattern="^\d+(,\d{1,2})?$"
        value={formatPrice(value)}
        required
        maxLength={7}
        onChange={(e) => {
          e.preventDefault();
          // the input should ignore if anything other than this pattern is entered
          // 1 or 22,90 or 22,9 or 22 or 33,10

          const value = parseFloat(e.currentTarget.value.replace("€", "").replace(",", "").trim());

          if (isNaN(value)) {
            return;
          }

          setValue(value);
        }}
      />
      <span
        className="absolute top-1/2 -translate-y-1/2"
        style={{ left: Math.max(value.toFixed(2).length * 10, 50) + "px" }}
      >
        €
      </span>
    </div>
  );
}
